<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('../../../assets/admin-panel/login-page/Background-Image.png')">
    <div class="main-container d-flex flex-column justify-content-center h-100">
        <div class="d-none d-md-block"></div>
        <div class="login-container">
            <div class="row align-items-center">
                <div class="col-md-7 col-lg-6 m-h-auto">

                    <div class="text-center">
                        <img class="img-fluid logo m-b-30" alt="" src="../../../assets/admin-panel/Header/ledger_280x60.png">
                    </div>

                    <nz-card class="m-b-100 shadow-lg">
                        <div class="d-flex align-items-center justify-content-end m-b-30">
                            <!-- <img class="img-fluid logo" alt="" src="../../../assets/admin-panel/login-page/logo.png"> -->
                            <a class="close-icon" routerLink="/"> <img src="../../../assets/admin-panel/forgetpassword/ic_clear.png" alt=""></a>
                        </div>

                        <div *ngIf="!validated" class="">
                            <form [formGroup]="mobileNumberForm" nz-form nzLayout="vertical" class="login-form" (ngSubmit)="validateMobileNumber()">
                                <nz-form-item>
                                    <nz-form-label [nzSm]="20" nzRequired nzFor="mobile">Enter Mobile Number</nz-form-label>
                                    <nz-form-control nzErrorTip="Please Enter your Mobile Number!">
                                        <nz-input-group>
                                            <input autocomplete="off" id="mobile" formControlName="phoneNumber" nz-input placeholder="Enter Mobile Number" type="number" pattern="\d*" maxlength="13" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                                        </nz-input-group>
                                    </nz-form-control>
                                </nz-form-item>

                                <nz-form-item>
                                    <nz-form-control>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <button [nzLoading]="loginConfirm" nz-button class="login-form-button">Submit</button>
                                        </div>
                                    </nz-form-control>
                                </nz-form-item>
                            </form>
                        </div>



                        <div *ngIf="validated && !enterNewPassword" class="">
                            <div class="text-center mb-3">
                                <p class="mobile-text">Enter 6-Digit Verification code we Sent to <b class="text-danger">{{phoneNo}}</b>
                            </div>

                            <form nz-form nzLayout="vertical " class="login-form ">
                                <div class="text-center mb-5">
                                    <ng-otp-input (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent" [config]="config"></ng-otp-input>
                                </div>

                                <nz-form-item>
                                    <nz-form-control>
                                        <div class="mb-3 text-center">
                                            <span class="font-size-13 text-muted ">Don't receive the code?</span>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center ">
                                            <button (click)="resendOtp()" nz-button class="login-form-button ">Resend OTP</button>
                                        </div>
                                    </nz-form-control>
                                </nz-form-item>
                            </form>
                        </div>

                        <div *ngIf="enterNewPassword" class="">
                            <form [formGroup]="confirmPasswordForm" nz-form nzLayout="vertical" class="login-form" (ngSubmit)="confirmPassword()">
                                <nz-form-item>
                                    <nz-form-label [nzSm]="20" nzRequired nzFor="pass">Enter New Password</nz-form-label>
                                    <nz-form-control nzErrorTip="Please Enter your New Password!">
                                        <nz-input-group [nzSuffix]="newTemplate">
                                            <input autocomplete="off" [type]="newPasswordVisible ? 'text' : 'password'" id="pass" formControlName="enteredPassword" nz-input placeholder="Enter your New Password ">
                                        </nz-input-group>
                                    </nz-form-control>
                                </nz-form-item>
                                <nz-form-item>
                                    <nz-form-label [nzSm]="20" nzRequired nzFor="newPass">Confirm New Password</nz-form-label>
                                    <nz-form-control nzErrorTip="Please Confirm Your New Password!">
                                        <nz-input-group [nzSuffix]="suffixTemplate">
                                            <input autocomplete="off" [type]="passwordVisible ? 'text' : 'password'" id="newPass" formControlName="confirmedPassword" nz-input placeholder="Confirm Your New Password ">
                                        </nz-input-group>
                                    </nz-form-control>
                                </nz-form-item>

                                <nz-form-item class="text-center">
                                    <nz-input-group>
                                        <button nz-button class="login-form-button ">Reset Password</button>
                                    </nz-input-group>
                                </nz-form-item>
                            </form>
                        </div>

                        <ng-template #prefixUser><i nz-icon nzType="user "></i></ng-template>
                        <ng-template #prefixLock><i nz-icon nzType="lock "></i></ng-template>
                    </nz-card>

                    <ng-template #suffixTemplate>
                        <i nz-icon [nzType]="passwordVisible ? 'eye' : 'eye-invisible'" (click)="passwordVisible = !passwordVisible"></i>
                    </ng-template>
                    <ng-template #newTemplate>
                        <i nz-icon [nzType]="newPasswordVisible ? 'eye' : 'eye-invisible'" (click)="newPasswordVisible = !newPasswordVisible"></i>
                    </ng-template>


                </div>
            </div>
        </div>
        <!-- <div class="d-none d-md-flex p-h-40 justify-content-between ">
            <span class=" ">© 2019 ThemeNate</span>
            <ul class="list-inline ">
                <li class="list-inline-item ">
                    <a class="text-dark text-link " href=" ">Legal</a>
                </li>
                <li class="list-inline-item ">
                    <a class="text-dark text-link " href=" ">Privacy</a>
                </li>
            </ul>
        </div> -->
    </div>
</div>

<button id="sign-in-button"></button>

<!-- [formGroup]="loginForm "  goes to line 12 -->
<!-- (ngSubmit)="submitForm() "  goes to line 12-->
<!-- formControlName="password " formControlName="name " goes to line 26 and goes to line 16 -->

<ngx-spinner bdColor="rgba(35,35,38,0.84)" size="medium" color="#ff0000" type="line-scale" [fullScreen]="true"></ngx-spinner>